export default class {
  constructor(context) {
    this.context = context;
    this.form = this.context.querySelector('[data-form="form"]');
    this.submit = this.context.querySelector('[data-form="submit"]');
    this.init();
  }

  init() {
    if (!this.form) {
      let element = this.context;

      while (element.parentElement) {
        element = element.parentElement;
        if (element.tagName.toLowerCase() === 'form') {
          this.form = element;
          break;
        }
      }
    }

    if (this.form) {
      this.form.addEventListener('submit', (event) => this.formSubmit(event));
    }

    if (this.submit) {
      this.submit.addEventListener('click', (event) => this.formSubmit(event));
    }
  }

  async formSubmit(event) {
    event.preventDefault();
    const form = this.form;
    const genericErrorMessageContainer = document.getElementById('generic-error-message');
    if (!form) {
      console.error('Form element not found');
      return;
    }

    if (!genericErrorMessageContainer) console.error('generic-error-message not found');

    const formData = new FormData(form);
    const action = form.getAttribute('action');
    try {
      const response = await fetch(action, {
        method: 'POST',
        body: formData,
      });

      if (response.status >= 200 && response.status < 400 && response.url) {
        window.location.href = response.url;
        return;
      }

      if (response.status >= 200 && response.status < 400 && !response.url) {
        genericErrorMessageContainer.style.display = 'block';
        genericErrorMessageContainer.textContent =
          'An unexpected error occurred. Please try again.';
        console.error('No redirect URL found');
        return;
      }

      if (response.status === 400) {
        const errors = await response.json();
        Object.keys(errors).forEach((field) => {
          const input = form.querySelector(`[name="${field}"]`);
          if (!input && field === 'recaptcha') {
            genericErrorMessageContainer.style.display = 'block';
            genericErrorMessageContainer.textContent =
              'Recaptcha failed. Please refresh your page and try again.';
            return;
          }
          if (input) {
            // the response contains the error validation message for each field key
            // this gets appended to each field validation error field.
            input.classList.remove('valid');
            input.classList.add('input-validation-error');
            input.setAttribute('aria-invalid', 'true');
            const errorSpan = document.createElement('span');
            errorSpan.id = `${field}-error`;
            errorSpan.className = 'field-validation-error';
            errorSpan.textContent = errors[field][0];
            const validationMessageSpan = form.querySelector(`[data-valmsg-for="${field}"]`);
            if (validationMessageSpan) {
              validationMessageSpan.classList.remove('field-validation-valid');
              validationMessageSpan.classList.add('field-validation-error');
              validationMessageSpan.innerHTML = '';
              validationMessageSpan.appendChild(errorSpan);
            }
          } else {
            console.error(`Input element for name attr on field ${field} not found`);
          }
        });
        return;
      }

      if (response.status === 500 || response.status >= 400) {
        genericErrorMessageContainer.style.display = 'block';
        genericErrorMessageContainer.textContent =
          'An unexpected error occurred. Please try again.';
      }
    } catch (error) {
      genericErrorMessageContainer.style.display = 'block';
      genericErrorMessageContainer.textContent = 'An unexpected error occurred. Please try again.';
    }
  }
}
